/**
 * v1 は同じ名前（`access_token` / `user_id` / `email` / `phone_number`）を
 * path=/ に書くため、v2 は path=/v2 に閉じて別のクッキーとして扱う。
 * 属性を 1 箇所に置いておかないと、書き込みと削除で path がズレて消えなくなる。
 */
const BASE_ATTRIBUTES = 'path=/v2; SameSite=Lax';

const EXPIRED = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';

const NAME_PREFIX = 'v2_';

const cookieName = (name: string): string => `${NAME_PREFIX}${name}`;

/**
 * Secure は https のときだけ付ける。
 * ブラウザは localhost を secure context として扱うので http の開発サーバーでも
 * 付けられるが、jsdom（テスト）は http だと Secure 付きを保存しないため揃えておく。
 */
const attributes = (): string =>
  window.location.protocol === 'https:' ? `${BASE_ATTRIBUTES}; Secure` : BASE_ATTRIBUTES;

export const setCookie = (name: string, value: string): void => {
  document.cookie = `${cookieName(name)}=${encodeURIComponent(value)}; ${attributes()}`;
};

/** 属性を揃えないと消えないので、書き込みと同じ path を使う */
export const removeCookie = (name: string): void => {
  document.cookie = `${cookieName(name)}=; ${attributes()}; ${EXPIRED}`;
};

export const getCookie = (name: string): string | undefined => {
  const prefix = `${cookieName(name)}=`;
  const hits = document.cookie.split('; ').filter(cookie => cookie.indexOf(prefix) === 0);

  if (hits.length === 0) {
    return undefined;
  }
  return decodeURIComponent(hits[0].slice(prefix.length));
};
